import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import Auth from "@/services/Auth";
import store from "@/store";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";
import NetworkIssue from "../views/NetworkIssue.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/browse",
    name: "applications-browse",
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ "../views/ApplicationsBrowse.vue")
  },
  {
    path: "/search",
    name: "applications-search",
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ "../views/ApplicationsSearch.vue")
  },
  {
    path: "/applications/:id",
    name: "application",
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ "../views/Application.vue")
  },
  {
    path: "/application-redirect/:id/:generation",
    name: "application-redirect",
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ "../views/ApplicationRedirect.vue")
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    props: true
  },
  {
    path: "/network-issue",
    name: "network-issue",
    component: NetworkIssue
  },
  {
    path: "*",
    redirect: { name: "404", params: { resource: "page" } }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  NProgress.start();
  await Auth.isLoaded();
  if (!(store.getters.userIsLoggedIn && store.getters.userHasSignedNda) && routeTo.matched.some(record => record.meta.requiresAuth)) {
    next("/");
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
